/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import {
  Autocomplete,
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { useEffect } from "react";
import { useState } from "react";
import { MOBLIE_VIEW_WIDTH } from "../../constants/constants";

const dropdown = css`
  margin-bottom: 20px;
  background-color: #121212;
  button {
    border-radius: unset;
    color: white;
  }
  .MuiOutlinedInput-root {
    padding: unset;
    color: white;
  }
  .MuiOutlinedInput-input {
    height: 1.5rem;
  }
  .MuiAutocomplete-option {
    color: black;
  }
  .MuiOutlinedInput-input {
    padding-left: 0 !important;
    font-size: 15px;
  }
`;

const imageBox = (image, matches) => css`
  background-image: url(${image});
  width: ${matches ? "80%" : "100%"};
  height: ${matches ? "20vw" : "15vw"};
  margin-bottom: 20px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
`;
const descriptionWrapper = css`
  font-size: 14px;
  line-height: 35px;
`;
const tableCell = () => css`
  width: 35%;
`;

export default function ProductTable({ tableRowNames, tableContent }) {
  const [firstImage, setFirstImage] = useState("");
  const [secondImage, setSecondImage] = useState("");
  const [firstValue, setFirstValue] = useState("");
  const [secondValue, setSecondValue] = useState("");
  const [tableOptions, setTableOptions] = useState([]);
  const [dataObj, setDataObj] = useState({});
  const matches = useMediaQuery(MOBLIE_VIEW_WIDTH);

  useEffect(() => {
    const data = {};
    tableContent?.map((item) => {
      data[item?.attributes?.model] = {};
      data[item?.attributes?.model]["description"] =
        item?.attributes?.description;
      data[item?.attributes?.model]["media"] =
        process.env.REACT_APP_BASEURL +
        item?.attributes?.media?.data?.attributes?.url;
      item?.attributes?.body[0]?.truckRows?.map(
        (ele) =>
          (data[item?.attributes?.model][
            ele?.industry_category?.data?.attributes?.rowName
          ] = ele?.value)
      );
    });
    setDataObj((prevState) => ({
      ...prevState,
      ...data,
    }));
  }, []);

  useEffect(() => {
    const tableArr = tableContent?.map((item, index) => {
      index === 0 &&
        setFirstImage(
          process.env.REACT_APP_BASEURL +
            item?.attributes?.media?.data?.attributes?.url
        );
      index === 1 &&
        setSecondImage(
          process.env.REACT_APP_BASEURL +
            item?.attributes?.media?.data?.attributes?.url
        );
      return item?.attributes?.model;
    });
    setTableOptions([...tableArr]);
    setFirstValue(tableArr[0]);
    setSecondValue(tableArr[1]);
  }, []);

  const setNewFirstValue = (event, newValue) => {
    setFirstValue(newValue);
    setFirstImage(dataObj?.[newValue]?.media);
  };

  const setNewSecondValue = (event, newValue) => {
    setSecondValue(newValue);
    setSecondImage(dataObj[newValue].media);
  };

  return (
    <TableContainer>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell style={{ width: "25%" }}></TableCell>
            <TableCell css={tableCell}>
              <Box>
                <Box css={() => imageBox(firstImage, matches)} />
                <Autocomplete
                  disableClearable
                  value={firstValue}
                  options={tableOptions}
                  css={dropdown}
                  sx={matches ? { width: "70%" } : { width: "100%" }}
                  onChange={setNewFirstValue}
                  renderInput={(params) => <TextField {...params} />}
                ></Autocomplete>
                <Typography
                  variant="body2"
                  style={{
                    width: matches ? "80%" : "100%",
                    color: "white",
                    height: "70px",
                  }}
                  css={descriptionWrapper}
                >
                  {dataObj?.[firstValue]?.description}
                </Typography>
              </Box>
            </TableCell>
            <TableCell css={tableCell}>
              <Box>
                <Box css={() => imageBox(secondImage, matches)} />
                <Autocomplete
                  disableClearable
                  value={secondValue}
                  options={tableOptions}
                  css={dropdown}
                  onChange={setNewSecondValue}
                  sx={matches ? { width: "70%" } : { width: "100%" }}
                  renderInput={(params) => <TextField {...params} />}
                ></Autocomplete>
                <Typography
                  variant="body2"
                  style={{
                    width: matches ? "80%" : "100%",
                    color: "white",
                    height: "70px",
                  }}
                  css={descriptionWrapper}
                >
                  {dataObj?.[secondValue]?.description}
                </Typography>
              </Box>
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody style={{ color: "white" }}>
          {tableRowNames?.map((item, index) => (
            <TableRow key={index}>
              <TableCell style={{ color: "white", width: "30%" }}>
                {item?.attributes?.rowName}
              </TableCell>
              <TableCell
                style={{
                  textAlign: "center",
                  color: "white",
                  width: "35%",
                }}
              >
                {dataObj?.[firstValue]?.[item?.attributes?.rowName]
                  ? dataObj?.[firstValue]?.[item?.attributes?.rowName]
                  : "-"}
              </TableCell>
              <TableCell
                style={{
                  textAlign: "center",
                  color: "white",
                  width: "35%",
                }}
              >
                {dataObj?.[secondValue]?.[item?.attributes?.rowName]
                  ? dataObj?.[secondValue]?.[item?.attributes?.rowName]
                  : "-"}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
